import React from "react";
import PhoneIcon from "@mui/icons-material/Phone";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { useTranslation } from "react-i18next";

// The web receipt's Support pop-up (ReceiptHeader), for web hailing: the DASH
// Taxi row with Call and WhatsApp. Web hailing has no hotel row and no chat.
const DASH_TAXI_PHONE =
  process.env.REACT_APP_CONTACT_SUPPORT || "+852 6433 0388";

export interface SupportModalProps {
  open: boolean;
  onClose: () => void;
}

const SupportModal: React.FC<SupportModalProps> = ({ open, onClose }) => {
  const { t } = useTranslation("hailing");
  if (!open) return null;

  const dialNumber = DASH_TAXI_PHONE.replace(/\s/g, "");

  return (
    <div
      onClick={onClose}
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30"
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="hailing-support-title"
        onClick={(event) => event.stopPropagation()}
        className="relative mx-2 flex w-full max-w-[400px] flex-col gap-6 rounded-2xl bg-white p-8"
      >
        <button
          type="button"
          onClick={onClose}
          aria-label={t("support.close")}
          className="absolute right-4 top-4 text-gray-500 hover:text-gray-700"
        >
          <span className="text-2xl font-bold">&times;</span>
        </button>
        <div
          id="hailing-support-title"
          className="mb-4 text-2xl font-bold text-gray-900"
        >
          {t("support.title")}
        </div>
        <div className="mb-2 flex flex-wrap items-center justify-between gap-x-3 gap-y-3">
          <div>
            <div className="whitespace-nowrap text-lg font-bold text-gray-800">
              {t("support.dashTaxi")}
            </div>
            <div className="whitespace-nowrap text-base text-gray-400">
              {DASH_TAXI_PHONE}
            </div>
            <div className="text-base text-gray-400">{t("support.hours")}</div>
          </div>
          <div className="ml-auto flex gap-3">
            <a
              href={`tel:${dialNumber}`}
              aria-label={t("support.call")}
              className="flex h-12 w-12 items-center justify-center rounded-full bg-blue-100"
            >
              <PhoneIcon sx={{ color: "#2563eb", fontSize: 25 }} />
            </a>
            <a
              href={`https://wa.me/${dialNumber}`}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={t("support.whatsapp")}
              className="flex h-12 w-12 items-center justify-center rounded-full bg-green-100"
            >
              <WhatsAppIcon sx={{ color: "#22c55e", fontSize: 25 }} />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SupportModal;
